import React, { useState } from 'react';
import { Transporter } from "../components/utils/constants";
import CustomerInvoiceTable from '../components/customerInvoice/customerInvoiceTable'
import CustomerInvoiceTransWorldTable from '../components/customerInvoice/1568/customerInvoiceTable'

function CustomerInvoice(props) {
    const [searchValue, setSearchValue] = useState('')

    const handleSearch = (e, data) => {
        setSearchValue(data.value)
    }

    return (
        <React.Fragment>
            <div className="ag=theme-material agOver">
                {
                    Transporter ?
                        <CustomerInvoiceTransWorldTable handleSearch={handleSearch} searchValue={searchValue} {...props} />
                        : <CustomerInvoiceTable handleSearch={handleSearch} searchValue={searchValue} {...props} />
                }
            </div>
        </React.Fragment>
    )
}


export default CustomerInvoice